import React from 'react';
import styles from '../styles/CompanyOverview.module.css';

function CompanyOverview() {
    return (
        <section className={styles.container}>
            <div className={styles.content}>
                <h3 className={styles.subTitle}>Parnas - パルナス -</h3>
                <h1 className={styles.mainTitle}>We help with rigging.</h1>
                <p className={styles.description}>
                    私たちは、リギング（CGを動かす仕組み作り）専門のクリエイター集団です。
                    日本中から優秀なクリエイターが集まり、
                    ゲーム・アニメ映像・広告など幅広い領域のCG制作を支援しています。
                </p>
                <p className={styles.missionSummary}>
                    ゲームやアニメなどを楽しむ世界中の人々の日常にささやかな感動を届けるべく、一つ一つのアセットに魂を込めて仕事をします。
                </p>

                {/* <button className={styles.button}>詳しく見る</button> */}
                {/* What is Rigging? セクションを追加 */}
                <div className={styles.riggingExplanation}>
                    {/* リギング装飾 (Bone/Joint Icon) */}
                    <div className={styles.riggingDeco}>
                        <svg viewBox="0 0 200 100" className={styles.boneSvg}>
                            {/* Bone 1 */}
                            <circle cx="20" cy="50" r="5" fill="var(--accent-blue)" />
                            <circle cx="100" cy="50" r="8" fill="none" stroke="var(--accent-blue)" strokeWidth="2" />
                            <path d="M25,50 L92,50" stroke="var(--accent-blue)" strokeWidth="1" />
                            {/* Bone 2 */}
                            <circle cx="180" cy="50" r="5" fill="var(--accent-cyan)" />
                            <path d="M108,50 L175,50" stroke="var(--accent-cyan)" strokeWidth="1" strokeDasharray="5 5" />
                        </svg>
                    </div>
                    <h2 className={styles.riggingTitle}>What is Rigging?</h2>
                    <p className={styles.riggingDescription}>
                        リギングとは、CGモデルを自在に操るための仕組み（コントローラー）を構築する工程です。<br />
                        キャラクターごとの最適な骨格（ボーン）設計、柔らかな質感を表現するためのデフォーマー設定、さらには操作範囲を緻密に制御するシステム構築など、その領域は多岐にわたります。<br />
                        アニメーターの制作効率を最大化し、プロジェクトの表現クオリティを根底から支える、非常に重要な工程です。
                    </p>
                </div>


            </div >
            <div className={styles.imageWrapper}>
                <img src="/images/VRchara_web_normal.png" alt="リギングの説明" className={styles.image} />
            </div>
        </section >
    );
}

export default CompanyOverview;
